import request, { ResponseData } from "../utils/request";
import { createStreamFetch } from "../utils/fetchStreamData";
import { PATH_PREFIX, ResCode } from "../constants/request";
import {
  EChatScore,
  ERegenerateJudge,
  IChatMessage,
  IChatRecvMessage,
  IChatSendMessage,
} from "../objects/chat/types";
import { CHAT_CHANNEL, CLIENT_CHAN } from "../objects/chat/constants";
import { calculateFileMd5 } from "../utils/file";
import {
  IRichModalFileSign,
  IRichModalFileDetail,
  IRichModalFileStatusInfo,
  IRichModalFileCommitInfo,
  IRichModalFileSignRes,
  UploadedFile,
} from "../objects/file/types";
import { isImageFileName } from "../objects/file/utils";

const PREFIX = `${PATH_PREFIX}/richmodal/v1.0.2`;

// 获取session信息
export async function getSessionInfo(params: {
  session_id: string;
}): Promise<ResponseData> {
  return await request.get(`${PREFIX}/session/info`, {
    ...params,
  });

  // return {
  //   "code": 0,
  //   "message": {
  //     "session_id": "string",
  //     "status": "work",
  //   },
  // };
}

// 获取搜索session列表
export async function getQuerySessionList(params: {
  keyword: string;
  next: string;
  page_size: number;
  client_chan?: string;
}): Promise<ResponseData> {
  return await request.get(`${PREFIX}/session_search`, {
    client_chan: "chatOnCom",
    channel: "chat-web",
    ...params,
  });
}

// 获取session列表
export async function getSessionList(params: {
  next: string;
  page_size: number;
  client_chan?: string;
}): Promise<ResponseData> {
  return await request.get(`${PREFIX}/session/list`, {
    client_chan: "chatOnR1",
    channel: "chat-web",
    // channel: "test",
    ...params,
  });
  // return {
  //   "code": 0,
  //   "message": [
  //     {
  //       "session_list": [
  //         {
  //           "session_id": "string",
  //           "status": "work",
  //           "time": "string",
  //           "title": "你好",
  //         },
  //         {
  //           "session_id": "string2",
  //           "status": "work",
  //           "time": "string",
  //           "title": "你好2",
  //         },
  //       ],
  //       "type": "top",
  //     },
  //     {
  //       "session_list": [
  //         {
  //           "session_id": "string3",
  //           "status": "work",
  //           "time": "string",
  //           "title": "你好3",
  //         },
  //       ],
  //       "type": "today",
  //     },
  //     {
  //       "session_list": [
  //         {
  //           "session_id": "string4",
  //           "status": "work",
  //           "time": "string",
  //           "title": "你好4",
  //         },
  //       ],
  //       "type": "week",
  //     },
  //   ],
  // };
}

// 获取聊天历史
export async function getChatList(params: {
  next?: string;
  page_size: number;
  session_id: string;
}): Promise<ResponseData<IChatMessage[]>> {
  return await request.post(`${PREFIX}/history`, {
    ...params,
  });
}

// 获取前几条聊天历史
export async function getFirstMessage(params: {
  next?: string;
  page_size: number;
  session_id: string;
}): Promise<ResponseData<IChatMessage[]>> {
  return await request.post(`${PREFIX}/first-message`, {
    ...params,
  });
}
// 删除session列表
export async function deleteSession(params: {
  session_id: string;
}): Promise<ResponseData> {
  return await request.delete(`${PREFIX}/session/${params.session_id}`, {});
}

// 编辑session标题
export async function editSessionTitle(params: {
  session_id: string;
  title: string;
}): Promise<ResponseData> {
  return await request.put(`${PREFIX}/session/edit-title`, {
    ...params,
  });
}

// 流式问答、示例问答
export function chat(
  params: {
    action: string;
    session_id: string;
    send_msg: IChatSendMessage[];
    channel: string;
    client_chan: string;
    query_type: string;
    parent_id?: string;
    file_ids?: string[];
    asr_voice_id?: string;
    guidance?: string; // 示例对话id
    web_search?: boolean;
  },
  {
    onMessage,
    onFinish,
    onError,
  }: {
    onMessage: (val: any) => Promise<void> | void;
    onFinish?: () => Promise<void> | void;
    onError?: (err: Error) => Promise<void> | void;
  },
): {
  abort: () => void;
  exec: () => void;
} {
  const { guidance, ...restParams } = params;
  console.log("----11--->", restParams);
  const { exec, abort } = createStreamFetch({
    url: !guidance
      ? `${PREFIX}/chat`
      : `${PREFIX}/guidance/answer?id=${guidance}`,
    options: {
      method: !guidance ? "POST" : "GET",
      body: !guidance ? restParams : undefined,
    },
    onMessage,
    onFinish,
    onError,
  });
  return {
    exec,
    abort,
  };
}
// 置顶session
export async function pinnedSession(params: {
  session_id: string;
}): Promise<ResponseData> {
  return await request.put(`${PREFIX}/session/top`, {
    ...params,
  });
}

// 取消置顶session
export async function unPinnedSession(params: {
  session_id: string;
}): Promise<ResponseData> {
  return await request.put(`${PREFIX}/session/cancel-top`, {
    ...params,
  });
}

export async function deleteFileQueryMsg(
  file_id: string,
  msgId: string,
): Promise<ResponseData> {
  return await request.delete(`${PREFIX}/${file_id}/${msgId}`);
}

// 获取对话示例
export async function getChatSampleList(): Promise<ResponseData> {
  return await request.get(`${PREFIX}/guidance/query`, {
    client_chan: "chatOnCom",
    channel: "chat-web",
  });
  // return {
  //   "code": 0,
  //   "message": [
  //     {
  //       "icon":
  //         "https://sensechat-ml.aoss.cn-sh-01.sensecoreapi-oss.cn/chat/prod/wb/static/media/icon2.3c78dc93368f5f7b7eb5.png",
  //       "query": [
  //         {
  //           "file": [
  //             {
  //               "name": "1生成式AI在中国：2万亿美元的经济价值.pdf",
  //               "url": "string",
  //             },
  //             {
  //               "name": "2生成式AI在中国：2万亿美元的经济价值.pdf",
  //               "url": "string",
  //             },
  //             {
  //               "name": "3生成式AI在中国：2万亿美元的经济价值.pdf",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "1",
  //           "message": "请帮我总计一下这些文档",
  //         },
  //         {
  //           "file": [
  //             {
  //               "name": "2生成式AI在中国：2万亿美元的经济价值.pdf",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "2",
  //           "message":
  //             "如今，科技发展日新月异，生成式AI正在从热烈讨论走向应用落地。各大公司已不再追问何为生成式AI，而是希望了解如何提高部署该技术的投资回报率（ROI）。这一转变表明，生成式AI的颠覆性潜能正日益得到业界的认可。从初创企业到行业巨头，每家公司都在考虑或试点部署生成式AI用例，以期增强竞争优势。",
  //         },
  //       ],
  //       "title": "文档问答",
  //       "type": "file1",
  //     },
  //     {
  //       "icon":
  //         "https://sensechat-ml.aoss.cn-sh-01.sensecoreapi-oss.cn/chat/prod/wb/static/media/icon2.3c78dc93368f5f7b7eb5.png",
  //       "query": [
  //         {
  //           "file": [
  //             {
  //               "name": "苹果的大模型冲刺：没有AI新产品，只有...",
  //               "url":
  //                 "https://zhidao.baidu.com/quest-nowyouanyanoneokanyaion/228450875.html",
  //             },
  //             {
  //               "name": "创始人复盘：AI搜索那么卷，Devv AI如何...",
  //               "url":
  //                 "https://zhidao.baidu.com/quest-nowyouanyanoneokanyaion/228450875.html",
  //             },
  //             {
  //               "name": "对话香港大学马毅："如果相信只靠Scalin...",
  //               "url":
  //                 "https://zhidao.baidu.com/quest-nowyouanyanoneokanyaion/228450875.html",
  //             },
  //           ],
  //           "id": "1",
  //           "message": "请帮我提炼这些文章的核心要点",
  //         },
  //         {
  //           "file": [
  //             {
  //               "name": "2生成式AI在中国：2万亿美元的经济价值.pdf",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "2",
  //           "message":
  //             "如今，科技发展日新月异，生成式AI正在从热烈讨论走向应用落地。各大公司已不再追问何为生成式AI，而是希望了解如何提高部署该技术的投资回报率（ROI）。这一转变表明，生成式AI的颠覆性潜能正日益得到业界的认可。从初创企业到行业巨头，每家公司都在考虑或试点部署生成式AI用例，以期增强竞争优势。",
  //         },
  //       ],
  //       "title": "公众号文章堆积如山没时间看？",
  //       "type": "link",
  //     },
  //     {
  //       "type": "other",
  //       "icon":
  //         "https://sensechat-ml.aoss.cn-sh-01.sensecoreapi-oss.cn/chat/prod/wb/static/media/userCenter.0ebba148635b662ebc276e09a2160c42.svg",
  //       "query": [
  //         {
  //           "file": [
  //             {
  //               "name": "请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "1",
  //           "message": "请帮我计算下图片中食物的卡路里",
  //         },
  //         {
  //           "file": [
  //             {
  //               "name": "2请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "2",
  //           "message": "2请帮我计算下图片中食物的卡路里",
  //         },
  //       ],
  //       "title": "图片问答",
  //     },
  //     {
  //       "type": "other",
  //       "icon":
  //         "https://sensechat-ml.aoss.cn-sh-01.sensecoreapi-oss.cn/chat/prod/wb/static/media/userCenter.0ebba148635b662ebc276e09a2160c42.svg",
  //       "query": [
  //         {
  //           "file": [
  //             {
  //               "name": "请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "1",
  //           "message": "创意写作",
  //         },
  //         {
  //           "file": [
  //             {
  //               "name": "2请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "2",
  //           "message": "2创意写作",
  //         },
  //       ],
  //       "title": "创意写作",
  //     },
  //     {
  //       "type": "other",
  //       "icon":
  //         "https://sensechat-ml.aoss.cn-sh-01.sensecoreapi-oss.cn/chat/prod/wb/static/media/userCenter.0ebba148635b662ebc276e09a2160c42.svg",
  //       "query": [
  //         {
  //           "file": [
  //             {
  //               "name": "请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "1",
  //           "message": "请帮我画一张端午节主题的海报图",
  //         },
  //         {
  //           "file": [
  //             {
  //               "name": "2请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "2",
  //           "message": "2请帮我画一张端午节主题的海报图",
  //         },
  //       ],
  //       "title": "AI绘画",
  //     },
  //     {
  //       "type": "other",
  //       "icon":
  //         "https://sensechat-ml.aoss.cn-sh-01.sensecoreapi-oss.cn/chat/prod/wb/static/media/userCenter.0ebba148635b662ebc276e09a2160c42.svg",
  //       "query": [
  //         {
  //           "file": [
  //             {
  //               "name": "请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "1",
  //           "message": "AI搜索AI搜索AI搜索AI搜索",
  //         },
  //         {
  //           "file": [
  //             {
  //               "name": "2请帮我计算下图片中食物的卡路里.jpg",
  //               "url": "string",
  //             },
  //           ],
  //           "id": "2",
  //           "message": "2AI搜索AI搜索AI搜索AI搜索AI搜索",
  //         },
  //       ],
  //       "title": "AI搜索",
  //     },
  //   ],
  // };
}

// 对话反馈（点赞score = 0、踩score = 1、 默认score = 10000）
export async function chatFeedback(params: {
  session_id: string;
  message_id: string;
  tag: string[];
  score: EChatScore;
}): Promise<ResponseData> {
  return await request.put(`${PREFIX}/feedback`, {
    ...params,
  });
}

// 获取签名
export async function getFileSign(
  files: File[],
): Promise<IRichModalFileSignRes[]> {
  const file_list: IRichModalFileSign[] = await Promise.all(
    files.map(item => {
      return new Promise<IRichModalFileSign>(r => {
        calculateFileMd5(item).then(res => {
          r({
            "MD5": res,
            "content_type": item.type,
            "name": item.name,
            "size": item.size,
            "type": isImageFileName(item.name) ? "image" : "file",
          });
        });
      });
    }),
  );
  return request
    .post(`${PREFIX}/file/presign-url`, {
      file_list,
    })
    .then(res => {
      if (res.code === ResCode.Success) {
        return res.message.map((item: IRichModalFileSignRes) => {
          const param = file_list.find(it => it.MD5 === item.file_md5);
          return {
            ...item,
            name: param?.name || "",
          };
        });
      } else {
        return Promise.reject(res);
      }
    });
}

export async function uploadFile(
  signOb: IRichModalFileSignRes,
  file: File,
): Promise<UploadedFile> {
  try {
    await window.fetch(signOb.url, {
      method: "put",
      body: file,
    });
    // console.log("[uploadFile] res", await res.json());
    return {
      file_id: signOb.file_id,
      file_name: file.name,
      status: "success",
      hash: signOb.file_md5,
      url: URL.createObjectURL(file),
    };
  } catch (e) {
    console.error("[uploadFile] e", e);
    return {
      file_id: signOb.file_id,
      file_name: file.name,
      status: "error",
      hash: signOb.file_md5,
      url: URL.createObjectURL(file),
    };
  }
}

// 获取签名
export async function commitFile(
  file_ids: string[],
  links?: string[],
  url?: string,
): Promise<IRichModalFileCommitInfo[]> {
  return request
    .post(url || `${PREFIX}/file/commit`, {
      file_ids,
      links,
    })
    .then(res => {
      if (res.code === ResCode.Success) {
        return res.message;
      } else {
        const res = file_ids.map(it => ({
          file_id: it,
          status: "error",
        }));

        if (links && links.length > 0) {
          res.push(
            ...links.map(it => ({
              file_id: "",
              links: it,
              status: "error",
            })),
          );
        }

        return res;
      }
    });
}

export function getParseStatus(
  fileList: string[],
): Promise<IRichModalFileStatusInfo[]> {
  // ): Promise<{ list: IRichModalFileStatusInfo[]; historyToken: number }> {
  return request
    .get(`${PREFIX}/file/status`, {
      file_ids: JSON.stringify(fileList),
      client_chan: "chatOnCom",
      channel: "chat-web",
    })
    .then(res => {
      if (res.code === ResCode.Success) {
        return res.message;
      } else {
        return Promise.reject(res);
      }
    });
}

export function getFileDetail(file_id: string): Promise<IRichModalFileDetail> {
  return request
    .get(`${PREFIX}/file/detail`, {
      file_id,
    })
    .then(res => {
      if (res.code === ResCode.Success) {
        return res.message;
      } else {
        return Promise.reject(res);
      }
    });
}

export function deleteFile(file_id: string): Promise<IRichModalFileDetail[]> {
  return request.delete(`${PREFIX}/file/${file_id}`).then(res => {
    if (res.code === ResCode.Success) {
      return res.message;
    } else {
      return Promise.reject(res);
    }
  });
}

// 缓存视频URL
export async function cacheVideoUrl(
  key: string,
  value: string,
): Promise<ResponseData> {
  return request
    .post(`${PATH_PREFIX}/video-edit/v1.0.0/cache`, {
      key,
      value,
    })
    .then(res => {
      if (res.code === ResCode.Success) {
        return res;
      } else {
        return Promise.reject(res);
      }
    });
}

// 获取缓存的视频URL
export interface ICacheFile {
  key: string;
  file_id: string;
  url: string;
}

interface ICacheResponse {
  code: number;
  message?: {
    files: Array<ICacheFile>;
  };
  error?: string;
}

export async function getCacheFile(
  keys: string[],
): Promise<Array<ICacheFile> | null> {
  return request
    .post(`${PATH_PREFIX}/video-edit/v1.0.0/cache-detail`, {
      keys,
    })
    .then((res: ICacheResponse) => {
      // 成功状态码为0，并且message数组不为空
      if (res.code === 0 && res.message && res.message?.files.length > 0) {
        // 返回第一个缓存视频的URL
        return res.message.files;
      } else {
        // 没有有效数据但状态码正确，返回null表示没有缓存
        return null;
      }
    })
    .catch(error => {
      console.error("获取视频缓存接口错误:", error);
      // 将错误对象转换为可读的错误信息
      if (error && error.code) {
        switch (error.code) {
          case 401:
            throw new Error("用户无商量权限");
          case 400:
            throw new Error(`参数错误: ${error.error || "未知错误"}`);
          case 500:
            throw new Error(`服务器内部错误: ${error.error || "未知错误"}`);
          default:
            throw new Error(`未知错误: ${error.error || "请求失败"}`);
        }
      }
      throw error; // 如果不是预期的错误格式，直接抛出
    });
}

// 意见反馈
export async function postUserFeedback(params: {
  user_feedback: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/user_feedback`, {
    ...params,
  });
}

// 重新生成评价
export async function judgeRegenerateMsg(params: {
  session_id: string;
  message_id: string;
  channel: string;
  compare_rating: ERegenerateJudge;
  parent_id?: string;
}) {
  return await request.put(`${PREFIX}/compare-rating`, {
    ...params,
  });
}

// 添加QA对
export async function createQAMsg(params: {
  parent_id: string;
  session_id?: string;
  recv_msg: IChatRecvMessage[];
  send_msg: IChatSendMessage[];
}) {
  return await request.post(`${PREFIX}/message/create`, {
    caller: "operate_rule",
    channel: CHAT_CHANNEL,
    client_chan: CLIENT_CHAN,
    ...params,
  });
}
